import React from "react";
import styles from "./DocumentsPage.module.css";

const DocumentsPage: React.FC = () => {
  return (
    <div className={styles.page}>
      <h1>Documente</h1>
      <p>În curând: gestionarea documentelor relevante pentru Mindspace.</p>
    </div>
  );
};

export default DocumentsPage;
